import Format from './IncidentReportFormat'
import schema from './schema'

export { Format, schema }

export default Format
